import { useQuery } from '@tanstack/react-query'

import { getBillingOverview } from './api'
import { BILLING_OVERVIEW_KEY } from './keys'

/* focus refetch is off globally, but paying happens on stripe's own page: the
 * tab is backgrounded when the subscription:changed broadcast fires, socket.io
 * does not replay it, and the page renders "Pay now" over a paid invoice until
 * someone reloads by hand. coming back to the tab is the signal. */
export function useBillingOverview() {
  return useQuery({
    queryKey: BILLING_OVERVIEW_KEY,
    queryFn: ({ signal }) => getBillingOverview(signal),
    refetchOnWindowFocus: true
  })
}
